export const SINGLE_PROFILE_START = 'SINGLE_PROFILE_START';
export const SINGLE_PROFILE_SUCCESS = 'SINGLE_PROFILE_SUCCESS';
export const SINGLE_PROFILE_ERROR = 'SINGLE_PROFILE_ERROR';
export const SINGLE_PROFILE_END = 'SINGLE_PROFILE_END';
